import { USER_EVENTS } from '@shared/core/user-events'
import { FC } from 'react'
import { Button, Typography } from 'src/modules/core/components'
import { useAddUserEvent } from 'src/modules/user-events/use-add-event'
import { useHasUserEvent } from 'src/modules/user-events/use-has-user-event'
import classes from './settings-booking-page-tab.module.scss'

export const BookingDismissBox: FC = () => {
  const { data: isDismissed, isLoading } = useHasUserEvent(USER_EVENTS.APPOINTMENT_BOOKING_DISMISSED)
  const addUserEvent = useAddUserEvent()

  const handleDismiss = () => {
    addUserEvent.mutate({ eventName: USER_EVENTS.APPOINTMENT_BOOKING_DISMISSED, once: true })
  }

  // Hide the box if the event exists or if still loading
  if (isLoading || isDismissed === true) {
    return null
  }

  return (
    <div className={classes.dismissBox}>
      <Typography variant="body" className={classes.dismissTitle}>
        Not interested?
      </Typography>
      <Typography variant="body" className={classes.dismissText}>
        Click here to dismiss the appointment booking feature. You can still come back and finish your setup later if
        you change your mind.
      </Typography>
      <Button
        variant="secondary"
        onClick={handleDismiss}
        className={classes.dismissButton}
        disabled={addUserEvent.isLoading}
        isLoading={addUserEvent.isLoading}
      >
        I&apos;m not interested in appointment bookings right now
      </Button>
    </div>
  )
}
